export default class CreateStockOrderProduct {
    thirdPartySku: string;
    count: number;
}